// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ow-c";
export var backButton = "_ow-4";
export var backIcon = "_ow-5";
export var chevronShortcut = "_ow-6";
export var container = "_ow-1";
export var editor = "_ow-8";
export var editorWrapper = "_ow-7";
export var prefix = "_ow-2";
export var searchIcon = "_ow-3";
export var suffix = "_ow-9";
export var suffixContent = "_ow-a";
export var suffixText = "_ow-b";
export var wrapper = "_ow-0";